export default "__VITE_ASSET___CCmJC2U__"